export const SideBarWidth: number = 240;
